// src/components/Hero.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../css/Hero.css';

const Hero = () => {
  const [photoUrl, setPhotoUrl] = useState('');

  useEffect(() => {
    const fetchBackgroundPhoto = async () => {
      try {
        const res = await axios.get('https://college-c1-backend.onrender.com/api/admin/background-photo');
        if (res.data && res.data.photo) {
          // Replace backslashes with slashes for correct URL
          const cleanPath = res.data.photo.replace(/\\/g, '/');
          setPhotoUrl(`https://college-c1-backend.onrender.com/${cleanPath}`);
        }
      } catch (error) {
        console.error('Failed to fetch background photo:', error);
      }
    };

    fetchBackgroundPhoto();
  }, []);

  return (
    <section className="hero">
      {photoUrl ? (
        <img src={photoUrl} alt="College Background" />
      ) : (
        <p>Loading background image...</p>
      )}
    </section>
  );
};

export default Hero;








// // src/components/Hero.js
// import React from 'react';
// import '../css/Hero.css';
// import collegeImg from '../image/np1747116205_97a1ac4eacfa60b69d42.png';

// const Hero = () => {
//   return (
//     <section className="hero">
//         <img src={collegeImg} alt="Email"  />
//     </section>
//   );
// };

// export default Hero;